import React from 'react';
import { Button } from '@cokitchen/cokitchen-components';
const AddManagersFooter = ({
  onClick,
  disabled,
  loading
}: {
  onClick: () => void;
  loading: boolean;
  disabled: boolean;
}) => {
  return (
    <Button
      color='primary'
      variant='block'
      className='mx-auto'
      loading={loading}
      onClick={onClick}
      disabled={disabled}>
      Confirm
    </Button>
  );
};

export default AddManagersFooter;
